export const iconOrderBy = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.0855103" width="16.0127" height="16" rx="4" fill="#F8F8F9" />
    <path
      d="M9.24643 5L13.0956 5"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.58829 10.1923L4.94793 11.551C5.02602 11.629 5.15256 11.629 5.23066 11.551L6.59066 10.1923M5.08947 11.1923V5.69226"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.24643 8.46155L11.0941 8.46155"
      stroke="#C2C2CD"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.24643 11.9231L10.0933 11.9231"
      stroke="#E0E3EB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const iconCopy = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.6447 13.7177C6.52411 14.8383 7.16404 14.1984 6.04346 15.319C3.80229 17.5601 0.440545 14.1984 2.68171 11.9572C3.80229 10.8366 6.04348 8.59544 7.16406 7.47485C8.28462 6.35429 9.66893 6.53832 10.5094 7.37874"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10.3553 4.28204C11.4759 3.16146 10.836 3.80138 11.9565 2.6808C14.1977 0.439637 17.5595 3.80138 15.3183 6.04255C14.1977 7.16313 11.9565 9.40432 10.8359 10.5249C9.71538 11.6455 8.33107 11.4614 7.49064 10.621"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconCopyWhite = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.31338 14.628C8.33287 15.6085 8.8928 15.0486 7.91229 16.0291C5.95127 17.9901 3.00974 15.0486 4.97076 13.0876C5.95127 12.1071 7.91231 10.146 8.89282 9.16553C9.87331 8.18504 11.0846 8.34606 11.82 9.08143"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.6866 6.37185C12.6671 5.39134 12.1072 5.95127 13.0877 4.97076C15.0487 3.00974 17.9903 5.95127 16.0292 7.91229C15.0487 8.8928 13.0877 10.8538 12.1072 11.8344C11.1267 12.8148 9.91542 12.6538 9.18004 11.9184"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const iconEmail = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 1C2.5 1 1 2.5 1 4V11.5C1 13 2.5 14.5 4 14.5H16C18.25 14.5 19 13 19 11.5V4C19 2.5 17.5 1 16 1H4Z"
      stroke="#3A3956"
      strokeWidth="2"
    />
    <path
      d="M4.75 4.75C5.27771 5.27771 7.77796 6.81102 9.3933 8.02328C9.75709 8.29629 10.2582 8.31559 10.6283 8.05123L15.25 4.75"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconEmailOpacity = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 1C2.5 1 1 2.5 1 4V11.5C1 13 2.5 14.5 4 14.5H16C18.25 14.5 19 13 19 11.5V4C19 2.5 17.5 1 16 1H4Z"
      stroke="#C2C2CD"
      strokeWidth="2"
    />
    <path
      d="M4.75 4.75C5.27771 5.27771 7.77796 6.81102 9.3933 8.02328C9.75709 8.29629 10.2582 8.31559 10.6283 8.05123L15.25 4.75"
      stroke="#C2C2CD"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconEmailWhite = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 1C2.5 1 1 2.5 1 4V11.5C1 13 2.5 14.5 4 14.5H16C18.25 14.5 19 13 19 11.5V4C19 2.5 17.5 1 16 1H4Z"
      stroke="#fff"
      strokeWidth="2"
    />
    <path
      d="M4.75 4.75C5.27771 5.27771 7.77796 6.81102 9.3933 8.02328C9.75709 8.29629 10.2582 8.31559 10.6283 8.05123L15.25 4.75"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconRedirect = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 1.75L5.5 8.5"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13 5.5L13 1.10004C13 1.04482 12.9552 1.00004 12.9 1.00004L8.5 0.999999"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M4 1H1.1C1.04477 1 1 1.04233 1 1.09756C1 1.98117 1 8.60089 1 10C1 11.5 2.5 13 4 13C5.86133 13 12.0534 13 12.9031 13C12.9583 13 13 12.9566 13 12.9013C13 12.4161 13 10.2949 13 10"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconRedirectWhite = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0937 5.90625L9.1875 11.8125"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.75 9.1875L15.75 5.35004C15.75 5.29481 15.7052 5.25004 15.65 5.25004L11.8125 5.25"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M7.875 5.25H5.35C5.29477 5.25 5.25 5.29135 5.25 5.34658C5.25 6.16276 5.25 11.9065 5.25 13.125C5.25 14.4375 6.5625 15.75 7.875 15.75C9.49549 15.75 14.8674 15.75 15.6536 15.75C15.7089 15.75 15.75 15.7053 15.75 15.6501C15.75 15.2011 15.75 13.3804 15.75 13.125"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const iconArrowLeft = (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 11L5.25 11"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9.1875 14.9375L5.33585 11.2594C5.22138 11.1478 5.22138 10.9442 5.33585 10.8325L9.1875 7.0625"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconArrowRight = (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2175 5L1.98242 5"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M6.97461 9L11.8577 5.26355C12.0028 5.15013 12.0028 4.94329 11.8577 4.82986L6.97461 1"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconArrowRightWhite = (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2175 5L1.98242 5"
      stroke="#ffffff"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M6.97461 9L11.8577 5.26355C12.0028 5.15013 12.0028 4.94329 11.8577 4.82986L6.97461 1"
      stroke="#ffffff"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconArrowBlue = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="8" fill="#2125FF" />
    <path
      d="M15.1875 12L8.25 12"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12 15L15.6682 12.1977C15.7773 12.1126 15.7773 11.9575 15.6682 11.8724L12 9"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconDataNotExists = (
  <svg
    width="72"
    height="64"
    viewBox="0 0 72 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="64" rx="16" fill="white" />
    <rect x="42" y="6" width="24" height="24" rx="12" fill="#2125FF" />
    <path
      d="M58 14L54 18M50 22L54 18M54 18L58 22M54 18L50 14"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconX = (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1L4 4M1 7L4 4M4 4L7 7M4 4L1 1"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconArrowTop = (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 6L5.7035 1.59811C5.83111 1.4673 6.0638 1.4673 6.19141 1.59811L10.5 6"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconPlus = (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5625 5.5H5.5M9.4375 5.5L5.5 5.5M5.5 5.5V1.5625M5.5 5.5L5.5 9.4375"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconPlusWhite = (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5625 5.5H5.5M9.4375 5.5L5.5 5.5M5.5 5.5V1.5625M5.5 5.5L5.5 9.4375"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconCalendar = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13.6333C1 14.5667 1.94118 15.5 2.88235 15.5L12 15.5C15 15.5 17 13.5 17 10.5V4.5C17 3.5 16 2.5 15 2.5L12.2941 2.5L5.70588 2.5L3 2.5C2 2.5 1 3.50602 1 4.5L1 13.6333Z"
      stroke="#3A3956"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1L7 1ZM5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4H5ZM5 1V4H7V1L5 1Z"
      fill="#3A3956"
    />
    <path
      d="M13 1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1L13 1ZM11 4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55228 13 4H11ZM11 1V4H13V1L11 1Z"
      fill="#3A3956"
    />
    <path
      d="M12 9.5L16.9999 9.5V10.5C16.9998 13.5 14.9997 15.5 11.9997 15.5H10L10 11.5C10 10.5 11.0122 9.5 12 9.5Z"
      fill="#3A3956"
    />
  </svg>
);

export const iconDownload = (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 17.5V3.5C1.5 2.39543 2.39543 1.5 3.5 1.5H11.0331C11.5772 1.5 12.0977 1.72162 12.4748 2.11378L15.9417 5.71933C16.2999 6.0919 16.5 6.58869 16.5 7.10555V17.5C16.5 18.6046 15.6046 19.5 14.5 19.5H3.5C2.39543 19.5 1.5 18.6046 1.5 17.5Z"
      stroke="#3A3956"
      strokeWidth="2"
    />
    <path
      d="M9 13.5L9 6"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M6 12L8.80233 14.9346C8.88741 15.0218 9.04254 15.0218 9.12761 14.9346L12 12"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const iconTrash = (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4.50003L3 4.5V18.5C3 19.0523 3.44772 19.5 4 19.5H14C14.5523 19.5 15 19.0586 15 18.5063V4.50003Z"
      stroke="#F52929"
      strokeWidth="2"
    />
    <path
      d="M6.75 9V15"
      stroke="#F52929"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.25 9V15"
      stroke="#F52929"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1.5 4.5H16.5"
      stroke="#F52929"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4.5L7.22361 2.05279C7.393 1.714 7.73926 1.5 8.11803 1.5H9.88197C10.2607 1.5 10.607 1.714 10.7764 2.05279L12 4.5"
      stroke="#F52929"
      strokeWidth="2"
    />
  </svg>
);

export const iconWhiteTrash = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4.00002L4 4V13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5552 12 13.0029V4.00002Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 7V11"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.5 7V11"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 4H13"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4L6.72361 2.55279C6.893 2.214 7.23926 2 7.61803 2H8.38197C8.76074 2 9.107 2.214 9.27639 2.55279L10 4"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export const iconBlackTrash = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4.00002L4 4V13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5552 12 13.0029V4.00002Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 7V11"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.5 7V11"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 4H13"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4L6.72361 2.55279C6.893 2.214 7.23926 2 7.61803 2H8.38197C8.76074 2 9.107 2.214 9.27639 2.55279L10 4"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const iconMessage = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.99998C19 14.8631 15.4878 18.25 10.6584 18.25H1.93831C1.5378 18.25 1.30155 17.8026 1.5254 17.4705L3.63413 14.3421C1.65847 11.7368 2.31706 7.39472 3.63413 5.65788C4.95121 3.92104 7.14633 1.74998 10.6585 1.74998C16.3134 1.74998 19 6.03714 19 9.99998Z"
      stroke="#3A3956"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const iconMessageWhite = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.99998C19 14.8631 15.4878 18.25 10.6584 18.25H1.93831C1.5378 18.25 1.30155 17.8026 1.5254 17.4705L3.63413 14.3421C1.65847 11.7368 2.31706 7.39472 3.63413 5.65788C4.95121 3.92104 7.14633 1.74998 10.6585 1.74998C16.3134 1.74998 19 6.03714 19 9.99998Z"
      stroke="#fff"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const iconTicket = (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89855 1.75458C9.29546 1.34348 10.099 1.32497 10.5055 1.71751L12.3677 3.51537C12.7743 3.90795 11.5922 5.08337 12.7388 6.19037C13.8854 7.29736 15.0186 6.07476 15.4252 6.46734L21.8285 12.6498C22.2352 13.0423 22.2449 13.846 21.848 14.2571L19.6319 16.5523C19.6319 16.5523 18.4854 15.4453 17.3277 16.6444C16.1701 17.8434 17.3166 18.9504 17.3166 18.9504L15.1006 21.2456C14.7037 21.6568 13.9002 21.6753 13.4936 21.2826L7.09022 15.1002C6.68361 14.7077 7.86564 13.5323 6.71908 12.4253C5.57251 11.3183 4.43932 12.5408 4.03271 12.1483L2.1706 10.3505C1.76398 9.95789 1.75428 9.15423 2.15118 8.74313L8.89855 1.75458Z"
      fill="#transparent"
    />
    <path
      d="M8.89855 1.75458C9.29546 1.34348 10.099 1.32497 10.5055 1.71751C10.5055 1.71751 11.707 2.8774 12.3677 3.51537C12.7743 3.90795 11.5922 5.08337 12.7388 6.19037C13.8854 7.29736 15.0186 6.07476 15.4252 6.46734C15.8318 6.85991 19.5922 10.4906 21.8285 12.6498C22.2352 13.0423 22.2449 13.846 21.848 14.2571C21.2724 14.8533 20.2783 15.8828 19.6319 16.5523C19.6319 16.5523 18.4854 15.4453 17.3277 16.6444C16.1701 17.8434 17.3166 18.9504 17.3166 18.9504C16.3433 19.9586 15.2886 21.0509 15.1006 21.2456C14.7036 21.6568 13.9002 21.6753 13.4936 21.2826C12.7566 20.5711 7.49683 15.4928 7.09022 15.1002C6.68361 14.7077 7.86564 13.5323 6.71908 12.4253C5.57251 11.3183 4.43932 12.5408 4.03271 12.1483C3.76603 11.8908 2.68263 10.8448 2.1706 10.3505C1.76398 9.95789 1.75428 9.15423 2.15118 8.74313C3.60649 7.2358 8.89855 1.75458 8.89855 1.75458ZM8.89855 1.75458C8.50165 2.16567 9.44981 1.18362 8.89855 1.75458Z"
      stroke="#C2C2CD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const iconTicketWhite = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89855 2.75458C9.29546 2.34348 10.099 2.32497 10.5055 2.71751L12.3677 4.51537C12.7743 4.90795 11.5922 6.08337 12.7388 7.19037C13.8854 8.29736 15.0186 7.07476 15.4252 7.46734L21.8285 13.6498C22.2352 14.0423 22.2449 14.846 21.848 15.2571L19.6319 17.5523C19.6319 17.5523 18.4854 16.4453 17.3277 17.6444C16.1701 18.8434 17.3166 19.9504 17.3166 19.9504L15.1006 22.2456C14.7037 22.6568 13.9002 22.6753 13.4936 22.2826L7.09022 16.1002C6.68361 15.7077 7.86564 14.5323 6.71908 13.4253C5.57251 12.3183 4.43932 13.5408 4.03271 13.1483L2.1706 11.3505C1.76398 10.9579 1.75428 10.1542 2.15118 9.74313L8.89855 2.75458Z"
      fill="transparent"
    />
    <path
      d="M8.89855 2.75458C9.29546 2.34348 10.099 2.32497 10.5055 2.71751C10.5055 2.71751 11.707 3.8774 12.3677 4.51537C12.7743 4.90795 11.5922 6.08337 12.7388 7.19037C13.8854 8.29736 15.0186 7.07476 15.4252 7.46734C15.8318 7.85991 19.5922 11.4906 21.8285 13.6498C22.2352 14.0423 22.2449 14.846 21.848 15.2571C21.2724 15.8533 20.2783 16.8828 19.6319 17.5523C19.6319 17.5523 18.4854 16.4453 17.3277 17.6444C16.1701 18.8434 17.3166 19.9504 17.3166 19.9504C16.3433 20.9586 15.2886 22.0509 15.1006 22.2456C14.7036 22.6568 13.9002 22.6753 13.4936 22.2826C12.7566 21.5711 7.49683 16.4928 7.09022 16.1002C6.68361 15.7077 7.86564 14.5323 6.71908 13.4253C5.57251 12.3183 4.43932 13.5408 4.03271 13.1483C3.76603 12.8908 2.68263 11.8448 2.1706 11.3505C1.76398 10.9579 1.75428 10.1542 2.15118 9.74313C3.60649 8.2358 8.89855 2.75458 8.89855 2.75458ZM8.89855 2.75458C8.50165 3.16567 9.44981 2.18362 8.89855 2.75458Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const iconReloadWhite = (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.875 12.05L14.3556 12.591C14.6458 12.8697 15.1042 12.8697 15.3944 12.591L14.875 12.05ZM17.5819 10.491C17.8807 10.2042 17.8904 9.72941 17.6035 9.4306C17.3167 9.13179 16.8419 9.1221 16.5431 9.40896L17.5819 10.491ZM13.2069 9.40896C12.9081 9.1221 12.4333 9.13179 12.1465 9.4306C11.8596 9.72941 11.8693 10.2042 12.1681 10.491L13.2069 9.40896ZM13.2069 15.741C13.5057 15.4542 13.5154 14.9794 13.2285 14.6806C12.9417 14.3818 12.4669 14.3721 12.1681 14.659L13.2069 15.741ZM9.40625 15.5C6.77101 15.5 4.6875 13.4567 4.6875 11H3.1875C3.1875 14.3423 6.00088 17 9.40625 17V15.5ZM4.6875 11C4.6875 8.54328 6.77101 6.5 9.40625 6.5V5C6.00088 5 3.1875 7.65773 3.1875 11H4.6875ZM9.40625 6.5C10.1677 6.5 11.3781 6.73442 12.3749 7.41841C13.3321 8.07527 14.125 9.16308 14.125 11H15.625C15.625 8.63692 14.5616 7.09973 13.2236 6.18159C11.9251 5.29058 10.401 5 9.40625 5V6.5ZM14.125 11V12.05H15.625V11H14.125ZM15.3944 12.591L17.5819 10.491L16.5431 9.40896L14.3556 11.509L15.3944 12.591ZM15.3944 11.509L13.2069 9.40896L12.1681 10.491L14.3556 12.591L15.3944 11.509ZM9.40625 17C9.82799 17 10.492 16.941 11.1769 16.7669C11.8487 16.5962 12.633 16.292 13.2069 15.741L12.1681 14.659C11.867 14.948 11.3753 15.1688 10.8075 15.3131C10.2528 15.454 9.71368 15.5 9.40625 15.5V17Z"
      fill="white"
    />
  </svg>
);

export const iconShield = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3858 17.4866C10.4612 17.5045 10.5389 17.5045 10.6143 17.4866C12.3323 17.0688 13.857 16.0995 14.9465 14.7344C16.036 13.3692 16.6268 11.6865 16.625 9.95425V6.26611C16.625 6.14394 16.5755 6.02638 16.4872 5.93995C16.3988 5.85351 16.2787 5.8051 16.1538 5.8051C14.1726 5.72557 12.2857 4.95568 10.8333 3.63485C10.649 3.45505 10.351 3.45505 10.1667 3.63485C7.98397 5.77102 4.87616 5.8051 4.84616 5.8051C4.58584 5.8051 4.375 6.0114 4.375 6.26612V9.95425C4.37324 11.6865 4.96394 13.3692 6.05352 14.7344C7.14307 16.0996 8.6679 17.0688 10.3858 17.4866Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M7.875 10.5L9.62087 12.1165C9.70089 12.1906 9.82551 12.187 9.90103 12.1083L13.125 8.75"
      stroke="#5056FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const iconFileUpload = (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.4375 16.375V4.625C4.4375 3.52043 5.33293 2.625 6.4375 2.625H12.6725C13.2166 2.625 13.7371 2.84662 14.1142 3.23878L17.0042 6.24433C17.3624 6.6169 17.5625 7.11369 17.5625 7.63055V16.375C17.5625 17.4796 16.6671 18.375 15.5625 18.375H6.4375C5.33293 18.375 4.4375 17.4796 4.4375 16.375Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M11 14.4375L11 7.875"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.375 9.1875L10.827 6.61973C10.9015 6.54342 11.0372 6.54342 11.1117 6.61973L13.625 9.1875"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const signout = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0937 1.90625L5.1875 7.8125"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.75 5.1875L11.75 1.35004C11.75 1.29481 11.7052 1.25004 11.65 1.25004L7.8125 1.25"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M3.875 1.25H1.35C1.29477 1.25 1.25 1.29135 1.25 1.34658C1.25 2.16276 1.25 7.90652 1.25 9.12503C1.25 10.4375 2.5625 11.75 3.875 11.75C5.49549 11.75 10.8674 11.75 11.6536 11.75C11.7089 11.75 11.75 11.7053 11.75 11.6501C11.75 11.2011 11.75 9.38038 11.75 9.125"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const iconFacebookColor = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0452 0C15.1241 0 16 0.875938 16 1.95481V14.0452C16 15.1241 15.1241 16 14.0452 16H10.7181V9.97141H12.7993L13.1953 7.3895H10.7181V5.71397C10.7181 5.00763 11.0641 4.31909 12.1737 4.31909H13.3V2.12097C13.3 2.12097 12.2778 1.94653 11.3006 1.94653C9.26031 1.94653 7.92681 3.18306 7.92681 5.42166V7.3895H5.65891V9.97141H7.92681V16H1.95481C0.875938 16 0 15.1241 0 14.0452V1.95481C0 0.875938 0.875906 0 1.95481 0H14.0452V0Z"
      fill="#1777F2"
    />
  </svg>
);

export const iconTwitterColor = (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.03169 13.5008C11.0694 13.5008 14.3718 8.49859 14.3718 4.16066C14.3718 4.01859 14.3718 3.87716 14.3623 3.73634C15.0047 3.27163 15.5593 2.69628 16 2.03716C15.4009 2.30263 14.7653 2.47669 14.1146 2.55363C14.7997 2.1435 15.3128 1.49794 15.5577 0.737938C14.9134 1.12028 14.2084 1.38978 13.4733 1.53475C12.8526 0.874719 11.9857 0.5 11.0798 0.5C9.27719 0.5 7.79397 1.98325 7.79397 3.78575C7.79397 4.03581 7.82253 4.28509 7.87903 4.52866C5.24097 4.39644 2.77966 3.14863 1.11359 1.09891C0.247219 2.59034 0.6955 4.52316 2.12991 5.48097C1.60756 5.4655 1.09644 5.32456 0.64 5.07009V5.11169C0.640437 6.66838 1.74772 8.02141 3.27359 8.32963C2.79034 8.46141 2.28319 8.48066 1.79138 8.38594C2.22034 9.71984 3.45734 10.6393 4.85825 10.6656C3.69606 11.579 2.25959 12.0751 0.781438 12.0736C0.52025 12.0731 0.259313 12.0573 0 12.0262C1.50106 12.9895 3.24813 13.5006 5.03169 13.4983"
      fill="#1DA1F2"
    />
  </svg>
);

export const iconInstagramColor = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C5.82731 0 5.55488 0.00921875 4.70159 0.0481563C3.85009 0.087 3.26853 0.222219 2.75966 0.42C2.23359 0.624437 1.78744 0.898 1.34272 1.34275C0.897969 1.78747 0.624406 2.23362 0.419969 2.75969C0.222188 3.26853 0.0869687 3.85009 0.048125 4.70159C0.0091875 5.55488 0 5.82731 0 8C0 10.1726 0.0091875 10.4451 0.048125 11.2983C0.0869687 12.1498 0.222188 12.7314 0.419969 13.2402C0.624406 13.7663 0.897969 14.2125 1.34272 14.6573C1.78744 15.102 2.23359 15.3755 2.75966 15.58C3.26853 15.7777 3.85009 15.913 4.70159 15.9518C5.55488 15.9907 5.82731 15.9999 8 15.9999C10.1726 15.9999 10.4451 15.9907 11.2983 15.9518C12.1498 15.913 12.7314 15.7777 13.2402 15.58C13.7663 15.3755 14.2125 15.102 14.6573 14.6573C15.102 14.2125 15.3755 13.7663 15.58 13.2402C15.7777 12.7314 15.913 12.1498 15.9518 11.2983C15.9907 10.4451 15.9999 10.1726 15.9999 8C15.9999 5.82731 15.9907 5.55488 15.9518 4.70159C15.913 3.85009 15.7777 3.26853 15.58 2.75969C15.3755 2.23362 15.102 1.78747 14.6573 1.34275C14.2125 0.898 13.7663 0.624437 13.2402 0.42C12.7314 0.222219 12.1498 0.087 11.2983 0.0481563C10.4451 0.00921875 10.1726 0 8 0V0ZM8 1.44147C10.1361 1.44147 10.3891 1.44959 11.2327 1.48809C12.0126 1.52369 12.4362 1.654 12.7181 1.76353C13.0915 1.90866 13.358 2.08203 13.638 2.36197C13.9179 2.64191 14.0913 2.90844 14.2364 3.28181C14.346 3.56372 14.4763 3.98731 14.5119 4.76728C14.5503 5.61087 14.5585 5.86391 14.5585 8C14.5585 10.1361 14.5503 10.3891 14.5119 11.2327C14.4763 12.0126 14.346 12.4362 14.2364 12.7181C14.0913 13.0915 13.9179 13.358 13.638 13.638C13.358 13.9179 13.0915 14.0913 12.7181 14.2364C12.4362 14.346 12.0126 14.4763 11.2327 14.5118C10.3892 14.5503 10.1362 14.5585 8 14.5585C5.86372 14.5585 5.61078 14.5503 4.76728 14.5118C3.98731 14.4763 3.56372 14.346 3.28181 14.2364C2.90841 14.0913 2.64191 13.9179 2.36194 13.638C2.082 13.358 1.90862 13.0915 1.76353 12.7181C1.65397 12.4362 1.52366 12.0126 1.48806 11.2327C1.44956 10.3891 1.44144 10.1361 1.44144 8C1.44144 5.86391 1.44956 5.61087 1.48806 4.76728C1.52366 3.98731 1.65397 3.56372 1.76353 3.28181C1.90862 2.90844 2.082 2.64191 2.36194 2.36197C2.64191 2.08203 2.90841 1.90866 3.28181 1.76353C3.56372 1.654 3.98731 1.52369 4.76728 1.48809C5.61087 1.44959 5.86391 1.44147 8 1.44147V1.44147Z"
      fill="url(#paint0_linear_3063_48249)"
    />
    <path
      d="M7.99875 10.6654C6.52597 10.6654 5.33206 9.47147 5.33206 7.99875C5.33206 6.52597 6.52597 5.33206 7.99875 5.33206C9.47147 5.33206 10.6654 6.52597 10.6654 7.99875C10.6654 9.47147 9.47147 10.6654 7.99875 10.6654ZM7.99875 3.89062C5.72987 3.89062 3.89062 5.72987 3.89062 7.99875C3.89062 10.2676 5.72987 12.1068 7.99875 12.1068C10.2676 12.1068 12.1068 10.2676 12.1068 7.99875C12.1068 5.72987 10.2676 3.89062 7.99875 3.89062V3.89062Z"
      fill="url(#paint1_linear_3063_48249)"
    />
    <path
      d="M13.2325 3.73341C13.2325 4.26363 12.8027 4.69341 12.2725 4.69341C11.7423 4.69341 11.3125 4.26363 11.3125 3.73341C11.3125 3.20322 11.7423 2.77344 12.2725 2.77344C12.8027 2.77344 13.2325 3.20322 13.2325 3.73341V3.73341Z"
      fill="url(#paint2_linear_3063_48249)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3063_48249"
        x1="9.40031"
        y1="-0.84776"
        x2="4.72475"
        y2="14.5991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#515BD4" />
        <stop offset="0.26" stopColor="#9510B8" />
        <stop offset="0.66" stopColor="#E51804" />
        <stop offset="1" stopColor="#FEDA77" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3063_48249"
        x1="9.39906"
        y1="-0.849009"
        x2="4.7235"
        y2="14.5979"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#515BD4" />
        <stop offset="0.26" stopColor="#9510B8" />
        <stop offset="0.66" stopColor="#E51804" />
        <stop offset="1" stopColor="#FFBF00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3063_48249"
        x1="9.40244"
        y1="-0.843915"
        x2="4.72688"
        y2="14.603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#515BD4" />
        <stop offset="0.26" stopColor="#9510B8" />
        <stop offset="0.66" stopColor="#E51804" />
        <stop offset="1" stopColor="#FFBF00" />
      </linearGradient>
    </defs>
  </svg>
);

export const iconYoutubeColor = (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6656 1.74891C15.4816 1.06047 14.9395 0.518375 14.2511 0.334406C13.0032 -1.19209e-07 7.99994 0 7.99994 0C7.99994 0 2.99666 -1.19209e-07 1.74875 0.334406C1.06047 0.518375 0.51825 1.06047 0.33425 1.74891C0 2.99666 0 5.60003 0 5.60003C0 5.60003 0 8.20341 0.33425 9.45103C0.51825 10.1395 1.06047 10.6817 1.74875 10.8657C2.99666 11.1999 7.99994 11.1999 7.99994 11.1999C7.99994 11.1999 13.0032 11.1999 14.2511 10.8657C14.9395 10.6817 15.4816 10.1395 15.6656 9.45103C16 8.20341 16 5.60003 16 5.60003C16 5.60003 16 2.99666 15.6656 1.74891Z"
      fill="#ED1F24"
    />
    <path
      d="M6.39844 8.00319L10.5553 5.60316L6.39844 3.20312V8.00319Z"
      fill="white"
    />
  </svg>
);

export const iconTiktokColor = (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8871 7.16663C13.0545 8.00066 14.4847 8.49144 16.0292 8.49144V5.52064C15.7369 5.52076 15.4453 5.49026 15.1593 5.42966V7.76813C13.6149 7.76813 12.1849 7.27735 11.0172 6.44332V12.5058C11.0172 15.5385 8.55747 17.9969 5.52332 17.9969C4.39126 17.9969 3.33898 17.6548 2.46484 17.0681C3.4625 18.0877 4.85377 18.7202 6.39298 18.7202C9.42735 18.7202 11.8872 16.2618 11.8872 13.229V7.16663H11.8871ZM12.9602 4.16949C12.3636 3.51807 11.9719 2.67614 11.8871 1.74536V1.36328H11.0628C11.2702 2.54622 11.978 3.5569 12.9602 4.16949ZM4.3839 14.741C4.05061 14.3042 3.87045 13.7698 3.87125 13.2203C3.87125 11.8332 4.99638 10.7086 6.38444 10.7086C6.6431 10.7084 6.90023 10.7481 7.1468 10.8263V7.78914C6.85871 7.74968 6.56796 7.73296 6.27724 7.73911V10.1031C6.03057 10.0249 5.77333 9.98524 5.51457 9.98542C4.12651 9.98542 3.00149 11.11 3.00149 12.4972C3.00149 13.478 3.56384 14.3273 4.3839 14.741Z"
      fill="#FE2C55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0172 6.44332C12.1849 7.27735 13.6149 7.76813 15.1593 7.76813V5.42966C14.2972 5.24619 13.534 4.79584 12.9601 4.16949C11.9779 3.5569 11.2702 2.54622 11.0627 1.36328H8.89749V13.2289C8.89258 14.6121 7.76937 15.7321 6.3843 15.7321C5.56808 15.7321 4.84295 15.3433 4.38375 14.741C3.56369 14.3273 3.00134 13.478 3.00134 12.4972C3.00134 11.11 4.12636 9.98542 5.51442 9.98542C5.78035 9.98542 6.03667 10.0268 6.2771 10.1031V7.73911C3.29628 7.80066 0.898926 10.235 0.898926 13.229C0.898926 14.7235 1.49594 16.0784 2.4648 17.0682C3.33894 17.6549 4.39122 17.997 5.52328 17.997C8.55743 17.997 11.0172 15.5385 11.0172 12.5059V6.44332Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1594 5.42972V4.79739C14.382 4.79857 13.6199 4.58096 12.9603 4.16944C13.5441 4.80836 14.313 5.24896 15.1594 5.42972ZM11.0629 1.36334C11.043 1.2503 11.0279 1.1365 11.0173 1.02222V0.640137H8.02765V12.5058C8.02285 13.889 6.89974 15.009 5.51456 15.009C5.10784 15.009 4.72394 14.9126 4.38389 14.741C4.84309 15.3434 5.56822 15.7322 6.38443 15.7322C7.76941 15.7322 8.89272 14.6122 8.89762 13.2289V1.36334H11.0629ZM6.27734 7.73917V7.06599C6.02752 7.03184 5.77566 7.01477 5.52352 7.0149C2.48905 7.0149 0.0292969 9.47337 0.0292969 12.5058C0.0292969 14.4071 0.996024 16.0826 2.46505 17.0682C1.49619 16.0783 0.89917 14.7234 0.89917 13.2289C0.89917 10.2351 3.29641 7.80072 6.27734 7.73917Z"
      fill="#25F4EE"
    />
  </svg>
);

export const externalLink = (
  <svg
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export const iconCheckBlue = (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7812 0.71875C15.0625 1.03125 15.0625 1.5 14.7812 1.78125L6.53125 10.0312C6.21875 10.3438 5.75 10.3438 5.46875 10.0312L1.21875 5.78125C0.90625 5.5 0.90625 5.03125 1.21875 4.75C1.5 4.4375 1.96875 4.4375 2.25 4.75L5.96875 8.46875L13.7188 0.71875C14 0.4375 14.4688 0.4375 14.75 0.71875H14.7812Z"
      fill="#5056FF"
    />
  </svg>
);

export const iconCheckWhite = (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7812 0.71875C15.0625 1.03125 15.0625 1.5 14.7812 1.78125L6.53125 10.0312C6.21875 10.3438 5.75 10.3438 5.46875 10.0312L1.21875 5.78125C0.90625 5.5 0.90625 5.03125 1.21875 4.75C1.5 4.4375 1.96875 4.4375 2.25 4.75L5.96875 8.46875L13.7188 0.71875C14 0.4375 14.4688 0.4375 14.75 0.71875H14.7812Z"
      fill="#fff"
    />
  </svg>
);

export const iconCircleSlashBlue = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0312 13.625L2.875 4.46875C2 5.59375 1.5 7 1.5 8.5C1.5 12.0938 4.40625 15 8 15C9.5 15 10.9062 14.5 12.0312 13.625ZM13.0938 12.5625C13.9688 11.4375 14.5 10.0312 14.5 8.5C14.5 4.9375 11.5625 2 8 2C6.46875 2 5.0625 2.53125 3.9375 3.40625L13.0938 12.5625ZM0 8.5C0 5.65625 1.5 3.03125 4 1.59375C6.46875 0.15625 9.5 0.15625 12 1.59375C14.4688 3.03125 16 5.65625 16 8.5C16 11.375 14.4688 14 12 15.4375C9.5 16.875 6.46875 16.875 4 15.4375C1.5 14 0 11.375 0 8.5Z"
      fill="#5056FF"
    />
  </svg>
);

export const iconClose = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4766 1.85156L7.78906 6.53906L12.4375 11.1875C12.8281 11.5391 12.8281 12.125 12.4375 12.4766C12.0859 12.8672 11.5 12.8672 11.1484 12.4766L6.46094 7.82812L1.8125 12.4766C1.46094 12.8672 0.875 12.8672 0.523438 12.4766C0.132812 12.125 0.132812 11.5391 0.523438 11.1484L5.17188 6.5L0.523438 1.85156C0.132812 1.5 0.132812 0.914062 0.523438 0.523438C0.875 0.171875 1.46094 0.171875 1.85156 0.523438L6.5 5.21094L11.1484 0.5625C11.5 0.171875 12.0859 0.171875 12.4766 0.5625C12.8281 0.914062 12.8281 1.5 12.4766 1.85156Z"
      fill="#5056FF"
    />
  </svg>
);

export const iconEdit = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.333 2.00001C11.5081 1.8249 11.716 1.686 11.9441 1.59128C12.1722 1.49657 12.4159 1.44775 12.6617 1.44775C12.9075 1.44775 13.1512 1.49657 13.3793 1.59128C13.6074 1.686 13.8153 1.8249 13.9904 2.00001C14.1655 2.17512 14.3044 2.383 14.3991 2.6111C14.4938 2.8392 14.5427 3.0829 14.5427 3.32868C14.5427 3.57446 14.4938 3.81817 14.3991 4.04628C14.3044 4.27439 14.1655 4.48227 13.9904 4.65738L4.65738 14.0001L1.33301 15.3334L2.66634 12.009L11.333 2.00001Z"
      stroke="#3A3956"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
